import * as React from 'react';
import DragHandlerIcon from '@atlaskit/icon/glyph/drag-handler';
import { fontSize } from '@atlaskit/theme';
import StarIcon from '@atlaskit/icon/glyph/star';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import * as grid from 'view/styles/grid';
import { SkeletonItem } from 'view/common/skeleton-item';
import {
    Root,
    IconContainer,
    Content,
    Actions,
    NameWrapper,
    Container,
    titleSkeletonHeight,
    ActionsLeft,
} from './styled';
import { DragHandlerWrapper } from '../project-card';

import type { ProjectCardSkeletonProps, BasicProjectCardSkeletonProps } from './types';

const ProjectsCardSkeleton: React.FunctionComponent<ProjectCardSkeletonProps | BasicProjectCardSkeletonProps> = ({
    isBasic,
    isFeatured,
}) => {
    return (
        <Root>
            <Container hasIcon>
                {!isBasic && isFeatured && (
                    <ActionsLeft>
                        <DragHandlerWrapper>
                            <DragHandlerIcon label="" size="xlarge" />
                        </DragHandlerWrapper>
                    </ActionsLeft>
                )}
                <IconContainer>
                    <SkeletonItem width={grid.multiple(6).px} height={grid.multiple(6).px} />
                </IconContainer>
                <Content>
                    <NameWrapper>
                        <SkeletonItem width={grid.multiple(11).px} height={titleSkeletonHeight} />
                    </NameWrapper>
                    <SkeletonItem width={grid.multiple(18).px} height={`${fontSize()}px`} />
                </Content>
                {!isBasic && (
                    <Actions>
                        {isFeatured ? (
                            <>
                                <StarFilledIcon label="" />
                            </>
                        ) : (
                            <StarIcon label="" />
                        )}
                    </Actions>
                )}
            </Container>
        </Root>
    );
};

export default ProjectsCardSkeleton;
